var map = {
	"./Executive1.svg": 7834,
	"./MeetingHall1.svg": 2038,
	"./MeetingHall2.svg": 9451,
	"./TeamOffice1.svg": 9721,
	"./TeamOffice2.svg": 9744,
	"./accessibility.svg": 8549,
	"./affordable.svg": 5413,
	"./collaborative.svg": 1521,
	"./comfortable.svg": 1836,
	"./complimentary.svg": 4292,
	"./constant.svg": 7362,
	"./groups.svg": 4354,
	"./image3.svg": 1341,
	"./image4.svg": 5529,
	"./img1.svg": 4826,
	"./logo-dark.svg": 7705,
	"./logo.svg": 9574,
	"./map.svg": 5077,
	"./next.svg": 8031,
	"./options/Executive Office.svg": 5369,
	"./options/Meeting Hall.svg": 5113,
	"./options/Shared Space.svg": 3734,
	"./options/Team Office.svg": 81,
	"./s1.svg": 3765,
	"./s2.svg": 1955,
	"./security.svg": 6087,
	"./serenity.svg": 9938,
	"./service1.webp": 6457,
	"./service2.svg": 1933,
	"./service3.svg": 1114,
	"./service4.svg": 6092,
	"./sharedspace1.svg": 860,
	"./sharedspace2.svg": 5486,
	"./slide.png": 2568,
	"./stimulating.svg": 7212,
	"./video.svg": 3815,
	"./wifi.svg": 5322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;